<template>
    <div>
        <v-tabs
            class="round-card"
            height="34"
            background-color="background-1"
            slider-color="primary">
            <v-tab key="Campi" ripple class="secondary-tab">
                Campi
            </v-tab>
            <v-tab key="Azioni" ripple class="secondary-tab">
                Azioni
            </v-tab>
            <v-tab key="Altro" ripple class="secondary-tab">
                Altro
            </v-tab>

            <v-tab-item class="background-1 pt-3 pb-1" key="Campi">
                <v-row class="ma-0">
                    <v-col class="pa-0 pt-2" cols="12">
                        <fields-selector model-def="supplier"></fields-selector>
                    </v-col>
                </v-row>
                <v-row class="ma-0 pb-offset">
                    <v-col class="pa-0 pt-2" cols="12">
                        <fields-selector model-def="productsupplier"></fields-selector>
                    </v-col>
                </v-row>
            </v-tab-item>

            <v-tab-item class="background-1 pt-3 pb-1" key="Azioni">
                <v-row class="ma-0">

                    <v-col class="pa-0 pt-2" cols="12">
                        <actions-selector model-def="supplier"></actions-selector>
                    </v-col>

                </v-row>
            </v-tab-item>

            <v-tab-item class="background-1 pt-3 pb-1" key="Altro">
                <v-row class="ma-0">

                    <v-col class="pa-0 pt-2" cols="12">
                        <suppliers-options></suppliers-options>
                    </v-col>

                </v-row>
            </v-tab-item>
        </v-tabs>
    </div>
</template>
<script>

import FieldsSelector from '@/components/common/FieldsSelector'
import ActionsSelector from '@/components/common/ActionsSelector'
import SuppliersOptions from '@/components/modules/crm/settings/SuppliersOptions'

    export default {
        name:'suppliers-settings',
        components: {
			FieldsSelector,
			ActionsSelector,
            SuppliersOptions
        },
		data() {
			return {

			}
		},
	}
</script>
